export enum LookupWindow {
  LAST_24_HOURS = 'LAST_24_HOURS',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_90_DAYS = 'LAST_90_DAYS',
  ALL_TIME = 'ALL_TIME',
}

export interface EmailNotificationConfigDTO {
  id: string;
  userEmail: string;
  recipientEmail: string;
  publisher: string;
  lookupWindow: LookupWindow;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface EnableEmailNotificationBody {
  recipientEmail: string;
  publisher: string;
  lookupWindow: LookupWindow;
}
